module.exports = __webpack_public_path__ + "src/img/del.a0c8a41f.svg";